import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PayperbyteWarnDialogComponent } from '../payperbyte-warn-dialog/payperbyte-warn-dialog.component';
import { HostelService } from '../services/hostel.service';
import { LoaderService } from '../services/loader.service';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-accomodation',
  templateUrl: './accomodation.component.html',
  styleUrls: ['./accomodation.component.css']
})
export class AccomodationComponent implements OnInit {

  constructor(public _hostel: HostelService, public dialog: MatDialog, public snackbar: MatSnackBar, public _loaderService: LoaderService, public log: LogService) { }

  public sessionArr = [];
  public hostelArr = [];
  ngOnInit() {
	this.log
		.addLog({
		action: "Access",
		component: "Accomodation",
		details: `Accessed Accomodation`,
	}).subscribe(data => { });
	this._hostel.getHostels().subscribe(data => {
		this.hostelArr = data;
		this._hostel.getSessions().subscribe(data => {
		  let sessions = data;
		  this._hostel.getStudentHostels().subscribe(data => {
			  let studentHostels = data;
			  this._loaderService.emitChange(false);
				sessions.map(s => {
					let hostels = studentHostels.filter(h => h.session_id == s.session_id);
					s['hostels'] = hostels
				})
				this.sessionArr = sessions;
		  })
		})
	})
  }

  addHostel(session){
	let dialogRef = this.dialog.open(PayperbyteWarnDialogComponent,{
		minWidth: '600px',
		data: {for: 'hostel', editing: false, hostels: this.hostelArr}
	})
	dialogRef.afterClosed().subscribe(result => {
		this._loaderService.emitChange(true);

		if(typeof(result) === undefined){
			this._loaderService.emitChange(false);
			
		}else{
			let form = {session_id: session.session_id, hostel_id: result.hostel_id};
			this._hostel.addHostel(form).subscribe(data => {
			this._loaderService.emitChange(false);
				if(data.success){
					this.snackbar.open(data.message, "Dismiss", {
						duration: 5000
					});
					this.log
						.addLog({
						action: "Add",
						component: "Accomodation",
						details: `Added Hostel to session with session_id ${session.session_id}`,
					}).subscribe(data => { });
					this.ngOnInit();
				}else{
					this.snackbar.open("An error occurred, please try again", "Dismiss", {
						duration: 5000
					})
				}
			})
		}
	})
  }

  editHostel(session, hostel){
	let dialogRef = this.dialog.open(PayperbyteWarnDialogComponent,{
		minWidth: '600px',
		data: {for: 'hostel', editing: true, hostels: this.hostelArr, ...hostel}
	})
	dialogRef.afterClosed().subscribe(result => {
		this._loaderService.emitChange(true);

		if(typeof(result) === undefined){
			this._loaderService.emitChange(false);
			
		}else{
			let form = {session_id: session.session_id, hostel_id: result.hostel_id};
			this._hostel.addHostel(form).subscribe(data => {
			this._loaderService.emitChange(false);
				if(data.success){
					this.snackbar.open(data.message, "Dismiss", {
						duration: 5000
					})
					this.log
						.addLog({
						action: "Edit",
						component: "Accomodation",
						details: `Edited Hostel with session_id ${session.session_id} & hostel_id ${result.hostel_id}`,
					}).subscribe(data => { });
					this.ngOnInit();
				}else{
					this.snackbar.open("An error occurred, please try again", "Dismiss", {
						duration: 5000
					})
				}
			})
		}
	})
  }

}
